import { ApolloError, isApolloError } from "@apollo/client"
import { ErrorCode } from "@aistihealth/web-common/src/util/gql/error-codes"

export const getErrorCode = (error: ApolloError) => {
  // TODO AIS-1001: Error might have several graphQLErrors, check how to support them
  return error.graphQLErrors && error.graphQLErrors[0]?.extensions?.code
}

/**
 * Is `error` an `ApolloError`, and does it have an error code specified in
 * `supportedErrorCodes`?
 *
 * This is intentionally not a type guard because the errors have the same type
 * regardless of error codes.
 */
export const hasErrorCode = (
  error: ApolloError,
  supportedErrorCodes: ErrorCode[],
): boolean => {
  return (
    // The type guard is not strictly necessary, but it's nice to have because error
    // objects often have `any` type
    isApolloError(error) && supportedErrorCodes.includes(getErrorCode(error))
  )
}
